"use server";
import { ssrFetcher } from "@website/fetcher/fetcher/ssrFetcher";
import { getChannel } from "@website/utils/channel/get-channel";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { filterXSS } from "xss";
import { CMSSeoContentData } from "./cms-types";

export const getCMSSeoContent = async (
  pageId: string,
  fallbackTitle?: string,
  fallbackDescription?: string
): Promise<CMSSeoContentData | undefined> => {
  let baseUrl = "/api/seo-content-v2";
  if (isChannel(["snapp-ir"])) {
    baseUrl = "/api/snapp-ir-seo-content";
  }

  const resolvedUrl = `${getOrigin()}${pageId}`;

  const url = `${
    process.env.NEXT_PUBLIC_BASE_URL_STRAPI_CMS
  }${baseUrl}?channel=${getChannel()}&route=${pageId}`;

  return ssrFetcher(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    next: {
      tags: ["cms-seo", pageId],
      revalidate: 600
    }
  })
    .then((response: CMSSeoContentData) => ({
      ...response,
      title: replaceSnappTripBasedOnChannel(response?.title || "") || null,
      fallbackTitle: replaceSnappTripBasedOnChannel(fallbackTitle || ""),
      description:
        replaceSnappTripBasedOnChannel(response?.description || "") || null, // because Next page router doesn't support undefined (in JSON serializing)
      fallbackDescription: replaceSnappTripBasedOnChannel(
        fallbackDescription || ""
      ),
      seoContent: filterXSS(response?.seoContent),
      resolvedUrl
    }))
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log("error", error);
      return {
        route: "",
        title: "",
        fallbackTitle:
          replaceSnappTripBasedOnChannel(fallbackTitle || "") || null,
        description: "",
        fallbackDescription:
          replaceSnappTripBasedOnChannel(fallbackDescription || "") || null,
        resolvedUrl,
        canonical: "",
        robots: "",
        redirect: "",
        pageTitle: "",
        seoContent: "",
        pageID: "",
        channel: "",
        FAQ: [],
        links: []
      };
    });
};
